(() => {
  const root = document.querySelector('.bs-information-content, .shopify-policy__body');
  if (!root || root.querySelector('.bs-page-toc')) return;
  const headings = [...root.querySelectorAll('h2')].filter(heading => !heading.closest('.bs-page-grid'));
  if (headings.length < 4) return;
  const label = document.currentScript?.dataset.tocLabel;
  if (!label) return;
  const toc = document.createElement('details');
  toc.className = 'bs-page-toc';
  toc.open = window.matchMedia('(min-width: 750px)').matches;
  const summary = document.createElement('summary');
  summary.textContent = label;
  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', label);
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `bs-page-topic-${index + 1}`;
    const anchor = document.createElement('a');
    anchor.href = `#${heading.id}`;
    anchor.textContent = heading.textContent.trim();
    nav.append(anchor);
  });
  toc.append(summary, nav);
  const lead = root.querySelector(':scope > .bs-page-lead');
  if (lead) lead.after(toc);
  else root.prepend(toc);
})();
